import { faCookie, faGamepad, faGuitar, faPizzaSlice, faVolleyball } from "@fortawesome/free-solid-svg-icons";

export const FREE_TIME = [
    faVolleyball,
    faCookie,
    faPizzaSlice,
    faGuitar,
    faGamepad,
]